import React from "react";
import PropTypes from "prop-types";
// material ui core
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";

// Custom components
import { Dashboard as DashboardLayout } from "../../../../layouts/";
// Styles
import { withStyles } from "@material-ui/core/styles";
import QRCode from "qrcode.react";
import TooltipToggleButton from "../../../../components/Tooltip/tooltipToggleButtons";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

// https://restcountries.eu/rest/v2/all?fields=name;alpha2Code
import {
  fetchSubscriptionEstimate,
  fetchPaymentIntentCreate,
  fetchSubscriptionCreate,
  clearTransactionInfo
} from "../../../../redux/actions/subscriptionActions";
// Site config
import {getEnvironmentName} from "../../../../utils"
const environment = getEnvironmentName()
const config = require("../../../../app_configuration").CONFIGURATION[environment];

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(2)
  },
  textfield: {
    margin: "8px auto",
    width: "100%"
  },
  toolbar: {
    margin: "4px"
  },
  bigAvatar: {
    width: 100,
    height: 100,
    margin: "auto"
  },
  buttonWrapper: {
    display: "flex",
    justifyContent: "space-between",
    margin: theme.spacing(2, 0, 2, 0)
  }
});

const estimateRequired = ["billing_zip", "billing_country", "numberOfLicences", "deployTheBot"];
const paymentIntentRequired = ["billing_zip", "billing_country", "numberOfLicences", "deployTheBot"];

class Subscription extends React.Component {
  state = {};

  handleButton = e => {
    // window.location.reload();
    this.props.clearTransactionInfo();
  };

  render() {
    const { classes } = this.props;
    return (
      <DashboardLayout title="Invoice Info">
        <Grid container spacing={5}>
          <Grid item lg={8} xs={12} md={6}>
            <Paper className={classes.root} elevation={1}>
              <Typography variant="h3" component="h3">
                Subscription Create Result
              </Typography>
              <pre>{JSON.stringify(this.props.transaction, null, 4)}</pre>
            </Paper>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12} style={{ display: "flex", justifyContent: "center" }}>
            <Button variant="outlined" color="primary" onClick={this.handleButton}>
              Clear Info
            </Button>
          </Grid>
        </Grid>
      </DashboardLayout>
    );
  }
}

Subscription.propTypes = {
  clearTransactionInfo: PropTypes.func
};

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(
      {
        clearTransactionInfo
      },
      dispatch
    ),
    dispatch
  };
}

Subscription = connect(
  mapStateToProps,
  mapDispatchToProps
)(Subscription);

export default withStyles(styles)(Subscription);
